import Button from '@admin/components/button'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import Picker from './picker'
import React from 'react'
class KeyFrameField extends React.Component {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.number,
    device: PropTypes.string,
    value: PropTypes.number,
    video: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    asset: null,
    timestamp: 0.00
  }

  _handleBack = this._handleBack.bind(this)
  _handleChoose = this._handleChoose.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    const { timestamp } = this.state
    return (
      <div className="maha-social-designer-keyframefield">
        COVER IMAGE: { pluralize('second', timestamp, true) } (<Button { ...this._getChoose() } />)
      </div>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { asset } = this.state
    if(!_.isEqual(prevState.asset, asset)) {
      this._handleChange()
    }
  }

  _getChoose() {
    return {
      label: 't(change)',
      className: 'link',
      handler: this._handleChoose
    }
  }

  _getPicker() {
    const { timestamp } = this.state
    const { video } = this.props
    return {
      timestamp,
      video,
      onBack: this._handleBack,
      onDone: this._handleDone
    }
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChoose() {
    this.context.form.push(Picker, this._getPicker.bind(this))
  }

  _handleChange() {
    const { asset, timestamp } = this.state
    this.props.onChange(asset ? {
      asset_id: asset.id,
      asset,
      timestamp
    } : null)
  }

  _handleDone(keyframe) {
    this.context.form.pop()
    this.setState({ 
      asset: keyframe.asset,
      timestamp: keyframe.timestamp
    })
  }

  _handleSet(keyframe)  {
    if(!keyframe) return
    this.setState({ 
      asset: keyframe.asset,
      timestamp: keyframe.timestamp
    })
  }

}

export default KeyFrameField
